{
  "shell": {
    "logo_alt": "Rhemn",
    "navUpgrade": "Passer à Pro",
    "navBilling": "Facturation"
  },
  "upgrade": {
    "badge": "Rhemn Pro",
    "title": "Votre onglet. Votre <em>dhikr</em>.<br />Sublimé.",
    "subtitle": "Toutes les fonctionnalités pour une journée plus intentionnelle — des heures de prière à la réflexion sur les versets par IA, en passant par la météo et les tâches prioritaires — dans un nouvel onglet calme et élégant.",
    "comparison_aria": "Comparaison des formules",
    "free": {
      "tierLabel": "Actuelle",
      "tierName": "Gratuit",
      "freeLabel": "Toujours gratuit",
      "list_aria": "Fonctionnalités de la formule gratuite"
    },
    "pro": {
      "list_aria": "Fonctionnalités de la formule Pro",
      "tierLabel": "Passer à",
      "tierName": "Pro",
      "pricePeriod": "/ mois",
      "priceAlt": "ou 39,99 $ / an"
    },
    "freeFeatures": {
      "clockDate": "Affichage de l'horloge et de la date",
      "verseOfDay": "Verset coranique du jour",
      "dailyBackground": "Photo d'arrière-plan quotidienne",
      "qiblaCompass": "Boussole Qibla",
      "basicTasks": "Tâches de base"
    },
    "proFeatures": {
      "weatherForecast": "Prévisions météo sur 5 jours",
      "verseFavorites": "Enregistrer et parcourir les versets favoris",
      "notesAi": "Notes avec analyse IA",
      "priorityTasks": "Gestion des tâches par priorité",
      "verseReflection": "Réflexion sur les versets par IA"
    },
    "plans": {
      "monthly": {
        "label": "Mensuel",
        "price": "$4.99",
        "period": "/ mois",
        "note": "Facturé mensuellement"
      },
      "yearly": {
        "label": "Annuel",
        "price": "$39.99",
        "period": "/ an",
        "note": "Deux mois offerts",
        "badge": "Économisez 33 %"
      }
    },
    "pricingTitle": "Rhemn Pro",
    "pricingDesc": "Annulable à tout moment. Votre accès se poursuit jusqu'à la fin de la période de facturation, sans frais partiels.",
    "billingPeriod_aria": "Période de facturation",
    "cta": "Passer au paiement sécurisé",
    "ctaLoading": "Redirection vers le paiement…",
    "promoManual": "Saisissez le code {{code}} sur la page suivante pour obtenir votre réduction.",
    "signingUpAs": "Inscription en tant que {{account}}",
    "trustSignals_aria": "Signaux de confiance",
    "reassurance": {
      "secureCheckout": "Paiement sécurisé via Stripe",
      "cancelAnytime": "Annulable à tout moment, sans condition",
      "accessUntilEnd": "Accès jusqu'à la fin de la période"
    },
    "errors": {
      "restoreSession": "Impossible de restaurer votre session. Veuillez réessayer depuis l'extension.",
      "checkoutFailed": "Échec du démarrage du paiement. Veuillez réessayer."
    }
  },
  "upgradeStatus": {
    "unlockedFeatures_aria": "Fonctionnalités débloquées",
    "unlockedFeatures": {
      "weatherForecast": "Prévisions météo sur 5 jours",
      "verseFavorites": "Enregistrer et parcourir les versets favoris",
      "notesAi": "Notes avec analyse IA",
      "priorityTasks": "Gestion des tâches par priorité",
      "verseReflection": "Réflexion sur les versets par IA"
    },
    "success": {
      "title": "Bienvenue dans Pro",
      "desc": "Votre abonnement est actif. Revenez à l'extension pour retrouver toutes les fonctionnalités Pro qui vous attendent.",
      "viewBilling": "Voir les détails de facturation",
      "closeTab": "Fermer cet onglet"
    },
    "cancel": {
      "title": "Paiement annulé",
      "desc": "Pas d'inquiétude — votre formule n'a pas changé et vous n'avez pas été débité. Vous pourrez passer à Pro dès que vous serez prêt.",
      "backToUpgrade": "Retour à la mise à niveau",
      "returnToExtension": "Revenir à l'extension"
    }
  },
  "billing": {
    "title": "Facturation",
    "subtitle": "Gérez votre abonnement et consultez l'historique des paiements.",
    "subscription_aria": "Statut de l'abonnement",
    "subscriptionTitle": "Abonnement",
    "loading_aria": "Chargement des informations de facturation",
    "planPro": "Rhemn Pro",
    "planFree": "Rhemn Gratuit",
    "statusLabels": {
      "active": "Actif",
      "trialing": "Essai gratuit",
      "past_due": "En retard de paiement",
      "unpaid": "Impayé",
      "canceled": "Annulé",
      "incomplete": "Incomplet",
      "none": "Aucun abonnement"
    },
    "planValues": {
      "proYearly": "Pro · Annuel",
      "proMonthly": "Pro · Mensuel"
    },
    "warnings": {
      "paymentFailedTitle": "Échec du paiement",
      "paymentFailedDesc": "Votre dernier paiement n'a pas abouti. Mettez à jour votre moyen de paiement via Gérer la facturation pour conserver l'accès Pro.",
      "trialEndingTitle": "Fin d'essai imminente",
      "trialEndingToday": "Votre essai gratuit se termine aujourd'hui, le {{date}}. Ajoutez un moyen de paiement pour conserver vos fonctionnalités Pro.",
      "trialEndingInDays_one": "Votre essai gratuit se termine dans {{count}} jour, le {{date}}. Ajoutez un moyen de paiement pour conserver vos fonctionnalités Pro.",
      "trialEndingInDays_other": "Votre essai gratuit se termine dans {{count}} jours, le {{date}}. Ajoutez un moyen de paiement pour conserver vos fonctionnalités Pro."
    },
    "cancellationScheduled": "Annulation planifiée. Vous conservez l'accès Pro complet jusqu'au <strong>{{date}}</strong>.",
    "sublabel": {
      "trialEndsToday": "L'essai se termine aujourd'hui",
      "trialDaysRemaining_one": "{{count}} jour restant d'essai",
      "trialDaysRemaining_other": "{{count}} jours restants d'essai",
      "renews": "Renouvellement le {{date}}",
      "accessUntil": "Accès jusqu'au {{date}}"
    },
    "kv": {
      "status": "Statut",
      "nextRenewal": "Prochain renouvellement",
      "trialEnds": "Fin de l'essai",
      "trialDaysLeft_one": "{{count}} jour restant",
      "trialDaysLeft_other": "{{count}} jours restants",
      "endsToday": "se termine aujourd'hui",
      "plan": "Formule"
    },
    "upgradeNudge": {
      "title": "Débloquez les fonctionnalités Pro",
      "desc": "Météo, heures de prière, réflexion sur les versets par IA et plus — 4,99 $/mois ou 39,99 $/an.",
      "cta": "Passer à Pro"
    },
    "actions": {
      "manageBilling": "Gérer la facturation et le moyen de paiement",
      "cancelConfirmTitle": "Annuler votre abonnement ?",
      "cancelConfirmDesc": "Vous conserverez l'accès Pro complet jusqu'à la fin de votre période de facturation en cours. Aucun remboursement partiel n'est accordé.",
      "canceling": "Annulation…",
      "yesCancel": "Oui, annuler",
      "keepPro": "Conserver Pro",
      "cancelSubscription": "Annuler l'abonnement"
    },
    "noSubscription": "Aucun abonnement trouvé.",
    "paymentHistory_aria": "Historique des paiements",
    "paymentHistoryTitle": "Historique des paiements",
    "invoices_aria": "Factures",
    "invoiceView": "Voir",
    "invoiceView_aria": "Voir la facture du {{date}}",
    "noInvoices": "Aucune facture pour l'instant.",
    "dangerZone_aria": "Zone sensible",
    "dangerZoneTitle": "Zone sensible",
    "deleteAccountTitle": "Supprimer le compte",
    "deleteAccountDesc": "Supprimez définitivement votre compte et toutes les données associées — tâches, notes, favoris et historique de facturation. Cette action est irréversible.",
    "deleteAccountBtn": "Supprimer le compte",
    "deleteConfirm": {
      "warning": "Ceci entraînera immédiatement et définitivement :",
      "list": {
        "deleteContent": "La suppression de toutes vos tâches, notes et versets favoris",
        "cancelSubscription": "L'annulation de tout abonnement actif (sans remboursement du temps non utilisé)",
        "removeAccount": "La suppression de votre compte de notre base de données",
        "signOut": "Votre déconnexion de tous les appareils"
      },
      "typeToConfirm": "Tapez <strong>DELETE</strong> pour confirmer",
      "inputPlaceholder": "DELETE",
      "deleting": "Suppression…",
      "confirmBtn": "Supprimer définitivement mon compte",
      "cancelBtn": "Annuler"
    },
    "errors": {
      "loadFailed": "Échec du chargement des informations de facturation.",
      "cancelFailed": "Échec de l'annulation de l'abonnement.",
      "deleteFailed": "Échec de la suppression du compte. Veuillez réessayer ou contacter le support.",
      "portalFailed": "Échec de l'ouverture du portail de facturation."
    }
  },
  "privacy": {
    "tocLabel": "Politique de confidentialité",
    "toc_aria": "Table des matières",
    "lastUpdated": "Dernière mise à jour<br />22 septembre 2026",
    "sections": {
      "overview": "Aperçu",
      "informationWeCollect": "Informations que nous collectons",
      "connectedServices": "Services connectés (Google, Todoist, Apple)",
      "howWeUse": "Comment nous utilisons vos informations",
      "howWeShare": "Comment nous partageons vos informations",
      "dataRetention": "Conservation des données",
      "yourRights": "Vos droits à la confidentialité",
      "california": "Résidents de Californie (CCPA/CPRA)",
      "cookies": "Cookies et stockage local",
      "security": "Sécurité des données",
      "changes": "Modifications de cette politique",
      "contact": "Nous contacter"
    },
    "headings": {
      "informationWeCollect": "Informations que nous collectons",
      "connectedServices": "Services connectés (Google, Todoist, Apple)",
      "howWeUse": "Comment nous utilisons vos informations",
      "howWeShare": "Comment nous partageons vos informations",
      "dataRetention": "Conservation des données",
      "yourRights": "Vos droits à la confidentialité",
      "california": "Résidents de Californie (CCPA / CPRA)",
      "cookies": "Cookies et stockage local",
      "security": "Sécurité des données",
      "changes": "Modifications de cette politique",
      "contact": "Nous contacter"
    }
  },
  "deleteAccount": {
    "intro": "La suppression de votre compte efface définitivement :",
    "list": {
      "account": "Votre compte et votre profil",
      "tasks": "Toutes les tâches",
      "notes": "Toutes les notes",
      "verses": "Versets enregistrés",
      "billing": "L'historique d'abonnement"
    },
    "irreversible": "Cette action est irréversible.",
    "appleNotice": "La suppression de votre compte n'annule pas un abonnement souscrit via l'App Store. Pensez à l'annuler aussi dans Réglages → Identifiant Apple → Abonnements.",
    "manageSubscription": "Gérer l'abonnement",
    "continueBtn": "Continuer la suppression",
    "keepBtn": "Conserver mon compte",
    "confirmTitle": "Supprimer votre compte ?",
    "confirmDesc": "Votre compte et toutes ses données seront définitivement supprimés. Cette action est irréversible.",
    "confirmBtn": "Supprimer définitivement mon compte",
    "deleting": "Suppression…",
    "error": "Impossible de supprimer votre compte. Vérifiez votre connexion et réessayez."
  }
}
